import AuthService from '../../utilities/services/auth.service'
import { OrganizationDashboardWrapper } from '../../components'

export default function OrganizationDashboardPage() {
  const organization = AuthService.getOrg()[0]
  return <OrganizationDashboardWrapper organization={organization} />
}
